<template>
    <q-page-sticky position="bottom-right" :offset="[16, 90]" class="floating-player" v-show="status !== 'stopped'">
        <q-fab color="primary" :icon="getMainButton" active-icon="fal fa-times" direction="up">
            <q-fab-action color="positive" class="white" :icon="getSecondaryButton" @click="playPausePlayer()" />
            <q-fab-action color="negative" class="white" icon="fal fa-stop" @click="stopPlayer()" />
            <q-fab-action color="secondary" class="white" icon="fal fa-list" @click="showPlayer()" />
        </q-fab>
    </q-page-sticky>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            status: 'podcasts/status'
        }),

        getMainButton() {
            if (this.status === 'playing') return 'fal fa-play'
            else if (this.status === 'paused') return 'fal fa-pause'
            else if (this.status === 'stopped') return 'fal fa-list'
        },

        getSecondaryButton() {
            if (this.status === 'playing') return 'fal fa-pause'
            else if (this.status === 'paused') return 'fal fa-play'
            else if (this.status === 'stopped') return 'fal fa-times'
        }
    },

    methods: {
        showPlayer() {
            this.$store.dispatch('podcasts/SET_MODAL', [true])
        },

        playPausePlayer() {
            if (this.status === 'playing') this.$store.dispatch('podcasts/SET_STATUS', ['paused'])
            else if (this.status === 'paused') this.$store.dispatch('podcasts/SET_STATUS', ['playing'])
        },

        stopPlayer() {
            this.$store.dispatch('podcasts/SET_STATUS', ['stopped'])
        }
    },
}
</script>

<style>

</style>